import type { RgbColor } from "utils/hslToRgb";

// Distinct at a glance and none of them the slate a plain room is drawn in.
export const ROOM_CIRCUIT_COLORS: RgbColor[] = [
  [37, 99, 235],
  [234, 88, 12],
  [22, 163, 74],
  [147, 51, 234],
  [219, 39, 119],
  [13, 148, 136],
  [202, 138, 4],
  [79, 70, 229],
  [220, 38, 38],
  [8, 145, 178],
];

export const roomCircuitColorOf = (index: number): RgbColor =>
  ROOM_CIRCUIT_COLORS[index % ROOM_CIRCUIT_COLORS.length];
